/* Material Detail — Fotorecord
   Gestisce tutte le istanze della sezione generica "material-detail": fronte, retro e —
   dall'11/09/2026 — la stampa, che e' un supporto di db_metro_quadro con gli stessi campi.
   Ascolta il CustomEvent indicato da data-mdet-event su ogni root.
   Legge il var globale data-mdet-init per il valore iniziale.
   Dati (descrizione, spessore, note, sku) dal metaobject via payload configuratore. */

var BADGES = {
  vetro:   'Vetro',
  crilex:  'Crilex (Plexiglass)',
  mdf:     'MDF',
  cartone: 'Cartone',
  foto:    'Stampa fotografica',
  tela:    'Stampa su tela'
};

/* La classe del materiale è un DATO: il campo `materiale` del metaobject, che i quattro
   dataset dei configuratori consegnano come `tipo` (vale per fronte e per retro). Fino a
   oggi si deduceva dallo sku — `sku.includes('mdf')`, `includes('crilex')` — cioè si
   leggeva un significato dentro un identificatore: con gli id opachi (mdftavolo →
   frre0060, crilexlastra100x140 → frfo0002) quelle include() non sollevano, tornano
   false. Il `nome` resta come rete di sicurezza per una sorgente che non porti `tipo`: è
   un'etichetta umana, non un identificatore, quindi il rename non la tocca. */
function getType(material) {
  if (!material) return '';
  var tipo = (material.tipo || '').toLowerCase().replace(/_/g, '-');
  if (tipo) return tipo;
  var nome = (material.nome || '').toLowerCase();
  if (nome.includes('crilex') || nome.includes('plexiglass')) return 'crilex';
  if (nome.includes('mdf'))     return 'mdf';
  if (nome.includes('cartone')) return 'cartone';
  if (nome.includes('vetro'))   return 'vetro';
  console.warn('[material-detail] materiale non dichiarato dal dato: badge omesso per',
               material.sku || material.nome || material);
  return '';
}

function formatSpessore(mm) {
  var n = parseFloat(mm);
  if (!n || n <= 0) return '';
  return String(n).replace('.', ',') + ' mm';
}

function populateSection(root, material) {
  var ph  = root.querySelector('.mdet-placeholder');
  var det = root.querySelector('.mdet-detail');
  if (!ph || !det) return;

  /* L'opzione «Nessuno» di fronte/retro e' una riga sintetica del configuratore (sku
     vuoto): non e' un materiale da descrivere, e' un'assenza — come il payload nullo. */
  var nessuno = !material || (!material.sku && /^nessun/i.test(material.nome || ''));
  if (nessuno) {
    ph.style.display  = '';
    det.style.display = 'none';
    return;
  }

  ph.style.display  = 'none';
  det.style.display = '';

  var q = function (sel) { return root.querySelector(sel); };
  // Valorizza la cella e nasconde l'intera riga se il dato manca
  var setRow = function (sel, text) {
    var el = q(sel);
    if (!el) return;
    el.textContent = text || '';
    var row = el.closest('.mdet-spec-row');
    if (row) row.style.display = text ? '' : 'none';
  };

  var tipo  = getType(material);
  var badge = q('.mdet-badge');
  if (badge) {
    badge.textContent = BADGES[tipo] || (tipo ? tipo.charAt(0).toUpperCase() + tipo.slice(1) : '');
    badge.className   = 'mdet-badge' + (tipo === 'crilex' ? ' mdet-badge--crilex' : '');
    badge.style.display = badge.textContent ? '' : 'none';
  }

  var nomeEl = q('.mdet-nome');
  /* Nome + codice pubblico nel nome («Crilex (plexiglass) 2 mm FRFO0002»), mirror di
     codice_prodotto.nome_cliente: dal 15/09/2026 la riga «Codice prodotto» non c'e' piu'. */
  var core = window.FOTORECORD && window.FOTORECORD.core;
  if (nomeEl) nomeEl.textContent = (core && core.nomeCliente) ? core.nomeCliente(material.nomeBreve || material.nome, material.sku) : (material.nome || '');

  setRow('.mdet-val-descrizione', material.descrizioneBreve || '');
  setRow('.mdet-val-spessore',    formatSpessore(material.spessoreMm));
  setRow('.mdet-val-note',        material.note || '');

  var img  = q('.mdet-media__img');
  var icon = q('.mdet-media__icon');
  if (img && icon) {
    if (material.immagineUrl) {
      img.src           = material.immagineUrl;
      img.alt           = material.nome || '';
      img.style.display = '';
      icon.style.display = 'none';
    } else {
      img.style.display  = 'none';
      icon.style.display = '';
    }
  }

  /* Foto dal vero (campione + angolo): per la stampa su tela sono le foto del telaio
     (metaobject stampa_configuratore, campi foto_campione/foto_angolo — 12/09/2026).
     Stessa meccanica del blocco foto di passepartout-detail.js. */
  var blkFoto = q('.mdet-block-foto');
  if (blkFoto) {
    var setFoto = function (fig, url, alt) {
      if (!fig) return;
      var im = fig.querySelector('img');
      if (url && im) { im.src = url; im.alt = alt; fig.style.display = ''; }
      else fig.style.display = 'none';
    };
    var fc = material.fotoCampioneUrl || '', fa = material.fotoAngoloUrl || '';
    setFoto(q('[data-mdet-foto="campione"]'), fc, (material.nome || '') + ' — il telaio');
    setFoto(q('[data-mdet-foto="angolo"]'),   fa, (material.nome || '') + ' — campione d’angolo');
    blkFoto.style.display = (fc || fa) ? '' : 'none';
  }
}

/* Stesso problema di detail-accordion.js, risolto allo stesso modo: incluso via
   <script type="module">, il browser valuta questo file una sola volta per pagina anche
   con più tag che puntano allo stesso URL (le PDP con più materiali — fronte + retro, e
   nei template multiplo anche di più — emettono 2-3 tag). Il marcatore sul dataset resta
   come difesa aggiuntiva per il caso di un root rimontato dinamicamente nel DOM. */
document.querySelectorAll('[data-mdet-event]').forEach(function (root) {
  if (root.dataset.mdetBound) return;
  root.dataset.mdetBound = '1';

  var eventName = root.dataset.mdetEvent;
  var initKey   = root.dataset.mdetInit;

  document.addEventListener(eventName, function (e) {
    populateSection(root, e.detail);
  });

  setTimeout(function () {
    if (initKey && window[initKey]) populateSection(root, window[initKey]);
  }, 0);
});
